import * as React from "react";
import { formatMessage } from "lib/globalize-util";
import { Tab, Tabs } from "material-ui/Tabs";
import { DimensionTab } from "../dimension-types";
import { DATATEST } from "constants/integration";
import { TabPanel } from "./tab-panel";
import { DoorsTabContainer } from "./doors";
import { SelectedDimension } from "../dimensions-tool-panel";
import { MetricsTabContainer } from "./metrics/metrics";
import { AttributesTabContainer } from "./attributes";

type Props = {
    setSelectedDimension: React.Dispatch<React.SetStateAction<SelectedDimension>>;
    setActiveTab: React.Dispatch<React.SetStateAction<DimensionTab>>;
    activeTab: DimensionTab;
    onImportAttributesToggle: () => void;
    assortmentDimensionMetrics: boolean;
};
export const TabsContainer = ({
    setSelectedDimension,
    activeTab,
    setActiveTab,
    onImportAttributesToggle,
    assortmentDimensionMetrics,
}: Props) => {
    // move refts of tabs to here
    const doorsTabRef = React.useRef<HTMLDivElement>(null);

    // decorate select and toggle dimension function with refs here
    return (
        <div className="tabWrapper">
            <Tabs value={activeTab} onChange={(index) => setActiveTab(index)}>
                <Tab className="tab" label={formatMessage("Doors")} value={0} />
                <Tab
                    className="tab"
                    label={formatMessage("Attributes")}
                    value={1}
                    data-test={DATATEST.ASSORTMENTS.GROUPING.ATTRIBUTES.OPEN}
                />
                {assortmentDimensionMetrics && <Tab className="tab" label={formatMessage("Metrics")} value={2} />}
            </Tabs>
            <TabPanel index={DimensionTab.Doors} value={activeTab} containerRef={doorsTabRef}>
                <DoorsTabContainer setSelectedDimension={setSelectedDimension} />
            </TabPanel>
            <TabPanel index={DimensionTab.Attributes} value={activeTab} containerRef={doorsTabRef}>
                <AttributesTabContainer
                    setSelectedDimension={setSelectedDimension}
                    onImportAttributesToggle={onImportAttributesToggle}
                />
            </TabPanel>
            {assortmentDimensionMetrics && (
                <TabPanel index={DimensionTab.Metrics} value={activeTab} containerRef={doorsTabRef}>
                    <MetricsTabContainer />
                </TabPanel>
            )}
        </div>
    );
};
